/**
 * `cn()` -- the shadcn/ui convention: clsx for conditional class lists, then
 * tailwind-merge so a caller's `className` prop beats a component's own default
 * instead of both landing in the class attribute and the cascade deciding.
 *
 * PRESENTATION ONLY. This file sits in `src/lib/` because that is where the
 * convention puts it and because the name collides with nothing here, but it is
 * NOT one of this directory's decision modules -- it knows nothing about
 * tenants, roles, routes or copy, and nothing in `src/lib/*.ts` imports it.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
